export default __webpack_public_path__ + "static/media/Travel-Lamu-Cover.dc412312.jpg";